
export default {
  name: 'ProductPhysicalVariant',

  props: {
    variants: {
      type: Array,
      default: () => [],
    },

    optionLink: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      variantData: null,
    }
  },

  computed: {
    items () {
      return this.variants?.map(({ slug: value, title: text }) => ({ value, text })) ?? []
    },

    getIndividualOptionLink () {
      if (!this.optionLink || !this.optionLink.value?.[0]) { return null }

      const { title: productOptionLink } = this.optionLink
      const { title: productOptionLinkValue } = this.optionLink.value?.[0] ?? {}

      return { productOptionLink, productOptionLinkValue }
    },

    queryText () {
      return this.items.find(variant => variant.value.toString() === this.variantData?.toString())?.value || ''
    },

    isOnlyOneVariant () {
      return this.items.length === 1
    },
  },

  watch: {
    variantData: {
      handler (variant) {
        if (!this.isOnlyOneVariant && variant) {
          this.$emit('selected-variant-slug', variant.toString())

          this.$router.push({
            path: this.$route.path,
            query: { ...this.$route.query, variant },
          })
        }
      },

      immediate: false,
    },
  },

  created () {
    this.variantData = this.$route?.query?.variant || ''

    if (this.isOnlyOneVariant) {
      this.variantData = this.items?.[0]?.value

      this.$emit('selected-variant-slug', this.variantData.toString())
    }
  },
}
